import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit} from '@angular/core';
import {FiltersService} from "../../../../shared/services/filters-service";
import {DropdownModule} from "primeng/dropdown";
import {FormsModule} from "@angular/forms";
import {CalendarModule} from "primeng/calendar";
import { LoginServices } from 'src/app/auth/login/services/login.service';

@Component({
    selector: 'app-date-filter',
    standalone: true,
    imports: [
        DropdownModule,
        FormsModule,
        CalendarModule
    ],
    templateUrl: './date-filter.component.html',
    styleUrl: './date-filter.component.scss'
})
export class DateFilterComponent implements OnInit {
    constructor(public filtersService: FiltersService, public cdr: ChangeDetectorRef, private ls: LoginServices) {
    }
    ngOnInit(): void {
        console.log(`ngOnInit() ->` + this.constructor.name)
    }


}
